// extracted by mini-css-extract-plugin
export default {"page":"Terms_page__Wu61A","title":"Terms_title__y3Kdn","updated":"Terms_updated__Hnvow"};